import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';

import { funcionContext } from '../../context/funcionContext'


import { MensajeAccion } from './MensajeAccion'

export class Mensajes extends Component {
    displayName = Mensajes.name
    
    constructor(props) {
        super(props);

        this.state = {
            mensajeInicial: [],
            mensajeBtn: [],
            loading: true,
            redirect: false,
            numeroGuia: props.numeroGuia,
            idModulo: props.idModulo,
            token: props.token,
            idPais: props.idPais,
            idCiudad: props.idCiudad,
            idCliente: props.idCliente,
            fechaVencimiento: props.fechaVencimiento,
            nombreConfirma: props.nombreConfirma,
            telefonoConfirma: props.telefonoConfirma,
            ciudadConfirma: props.ciudadConfirma,
            direccionBaseConfirma: props.direccionConfirma,
            vencido: false,
            valorPagar: props.valorPagar
        };

        
    }

    componentDidMount() {
        let funcion = this.context;
        let vence = new Date(this.state.fechaVencimiento);
        let hoy = new Date(); //Fecha actual

            //fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeConfirmacion/' + funcion + '/0/' + this.state.idModulo, {
            //    headers: {
            //        'authorizedtoken': this.state.token,
            //        'user': window.env.API_USER,
            //        'refnumber': this.state.numeroGuia
            //    }
            //})//El 1 correpsonde al paso 1 llamado por defecto en el primer llamado de la pagina
            //    .then(response => response.json())
            //    .then(data => {
            //        this.setState({ mensajeInicial: data, vencido: true });
            //    });

        fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeConfirmacion/' + funcion + '/1/' + this.state.idModulo, {
                headers: {
                    'authorizedtoken': this.state.token,
                    'user': window.env.API_USER,
                    'refnumber': this.state.numeroGuia
                }
            })//El 1 correpsonde al paso 1 llamado por defecto en el primer llamado de la pagina
                .then(response => response.json())
                .then(data => {
                    this.setState({ mensajeInicial: data });

                    fetch(window.env.API_DOMAIN_ADDR + '/api/parametros/MensajeBtnConfirmacion/' + funcion + '/' + data.flujo + '/' + this.state.idModulo, {
                        headers: {
                            'authorizedtoken': this.state.token,
                            'user': window.env.API_USER,
                            'refnumber': this.state.numeroGuia
                        }
                    })//El 1 correpsonde al paso 1 llamado por defecto en el primer llamado de la pagina
                        .then(response => response.json())
                        .then(dataBtn => {
                            this.setState({ mensajeBtn: dataBtn,  loading: false });
                        });

                });
    }

    setRedirect = () => {
        this.setState({
            redirect: true
        })
    }

    renderRedirect = () => {
        return <MensajeAccion numeroGuia={this.state.numeroGuia} idPais={this.state.idPais} idCiudad={this.state.idCiudad} idModulo={this.state.idModulo} idCliente={this.state.idCliente} token={this.state.token} nombreConfirma={this.state.nombreConfirma} valorPagar={this.state.valorPagar} telefonoConfirma={this.state.telefonoConfirma} ciudadConfirma={this.state.ciudadConfirma} direccionBaseConfirma={this.state.direccionBaseConfirma} ></ MensajeAccion>
    }
    
    static renderMensajeInicial(mensajeInicial, c) {
        return (
            <form>
                <Grid fluid className="grid" style={{ display: c.state.vencido ? 'none' : 'block' }}>
                    <Row className="banner">
                        <Col sm={6} className="bannerCol">
                            <img src="/media/images/Tenemos_novedad.png" />
                            <span className="texto"><h1>TENEMOS UNA NOVEDAD</h1><h2>con tu mercancía / documento</h2></span>
                        </Col>
                    </Row>
                </Grid>
                <Grid fluid className="grid">
                    <Row>
                        <Col sm={10} className="gridCol t">
                            <div className="msjNovedad">
                                <div className="bg">
                                    <div className="cont">
                                        <label>{mensajeInicial.mensaje}</label>
                                        <input style={{ visibility: c.state.vencido ? 'hidden' : 'visible' }} type="button" onClick={c.setRedirect} value={c.state.mensajeBtn[0].mensaje} />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </form>
        );
    }

    render() {
        let content = this.state.loading
            ? <p><em>Loading...</em></p>
            : Mensajes.renderMensajeInicial(this.state.mensajeInicial,this);

        if (!this.state.redirect) {
            return (
                <div>
                   { content }
                </div>
            );
        } else {
            return this.renderRedirect();
        }
    }
}

Mensajes.contextType = funcionContext;
